var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalenderBlank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 64,
    viewBox: "0 0 58 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 42059"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 42061"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M43.2504 0.835938C41.5404 0.835938 40.4004 1.97594 40.4004 3.68594V9.38594H46.1004V3.68594C46.1004 1.97594 44.9604 0.835938 43.2504 0.835938ZM14.7504 0.835938C13.0404 0.835938 11.9004 1.97594 11.9004 3.68594V9.38594H17.6004V3.68594C17.6004 1.97594 16.4604 0.835938 14.7504 0.835938Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M48.95 63.5328H9.05C4.49 63.5328 0.5 59.622 0.5 54.5078V18.4078C0.5 13.5945 4.205 9.38281 9.05 9.38281H48.95C53.51 9.38281 57.5 13.2936 57.5 18.4078V54.8086C57.5 59.622 53.795 63.5328 48.95 63.5328Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M57.5 17.9375H0.5V23.6375H57.5V17.9375Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 42060"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1336",
    x: 19.1279,
    y: 37.6406,
    width: 5.28066,
    height: 22.6412,
    rx: 2.64033,
    transform: "rotate(-45 19.1279 37.6406)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1337",
    width: 5.28066,
    height: 22.6412,
    rx: 2.64033,
    transform: "matrix(-0.707107 -0.707107 -0.707107 0.707107 38.8711 37.6406)",
    fill: "white"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalenderBlank);
export default __webpack_public_path__ + "static/media/calenderBlank.6d001356f5028aeacadc9ce942bebd9b.svg";
export { ForwardRef as ReactComponent };